import EmbedAutomaticAccountCreation from 'app/developer-v3/pages/embed/automatic-account-creation';

export default {
  routes: {
    '.': EmbedAutomaticAccountCreation,
  },
};
